import { Box } from "@mui/material";
import { Tab } from "react-admin";
import { PageHeader } from "@/components/common/PageHeader";
import { AuditLogBox } from "@/components/common/AuditLogBox";
import { ResourceName } from "@/types";
import { StyledShow } from "@/components/ui/react-admin/StyledShow";
import { StyledTabbedShowLayout } from "@/components/ui/react-admin/StyledTabbedShowLayout";
import { PageHeaderActions } from "@/components/common/PageHeaderActions";
import { PageContent } from "@/components/common/PageLayout";
import { getResourceIcon } from "@/utils/icons";
import { useResourcePermissions } from "@/hooks/useResourcePermissions";
import { PartnerOverviewTab } from "./components/PartnerOverviewTab";
import { PartnerBrandingTab } from "./components/PartnerBrandingTab";
import { PartnerTaskConfigSection } from "./components/PartnerTaskConfigSection";

export const PartnerShow = () => {
  const PartnerIcon = getResourceIcon(ResourceName.PARTNERS);

  return (
    <StyledShow actions={false}>
      <Box>
        <PageHeader
          titleKey="partner_company_name"
          statusKey="status"
          hideSectionTitle
          headerIcon={<PartnerIcon sx={{ fontSize: 28, color: "primary.main" }} />}
          rightContent={<PartnerShowActions />}
        />
        <PageContent>
          <PartnerTabbedShowLayout />
        </PageContent>
      </Box>
    </StyledShow>
  );
};

const PartnerShowActions = () => {
  const { canDelete } = useResourcePermissions(ResourceName.PARTNERS);

  return (
    <PageHeaderActions
      actions={{
        delete: canDelete,
      }}
    />
  );
};

const PartnerTabbedShowLayout = () => {
  return (
    <StyledTabbedShowLayout>
      <Tab label="Overview">
        <PartnerOverviewTab />
      </Tab>
      <Tab label="Branding" path="branding">
        <PartnerBrandingTab />
      </Tab>
      <Tab label="Task Configuration" path="task-config">
        <PartnerTaskConfigSection />
      </Tab>
      <Tab label="Audit Log" path="audit">
        <AuditLogBox tableName={ResourceName.PARTNERS} />
      </Tab>
    </StyledTabbedShowLayout>
  );
};
